import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { isEmpty, get } from 'lodash';
import ComponentTitle from 'components/shared/ComponentTitle';
import { searchUserByEmail, createMember, subscribe, generateRandomPassword } from 'utils/MemberUtils';
import { GRID_SYSTEM, COLOR_STYLE, TITLE_TYPE } from 'constants/FRNBaseStyles';
import { validateEmail } from 'utils/ValidateUtils';
import { SUBSCRIBE_SUCCESS_TITLE, SUBSCRIBE_SUCCESS_TEXT, SUBSCRIBE_FAIL} from 'constants/MemberFormDefaultMessage';
const ZIPCODE_DEFAULT = 10017;

class NewsletterSubscribe extends Component {
    static propTypes = {
        distributionList: PropTypes.array,
        componentTitle: PropTypes.string,
        componentTitleType: PropTypes.string,
        title: PropTypes.string,
        titleColor: PropTypes.string,
        text: PropTypes.string,
        textColor: PropTypes.string,
        successTitle: PropTypes.string,
        successMessage: PropTypes.string,
        backgroundColor: PropTypes.string,
        overflowBackground: PropTypes.bool,
        alignment: PropTypes.oneOf(['left', 'center', 'right']),
        roundedCorner: PropTypes.oneOf(['slight', 'strong', 'no']),
        buttonText: PropTypes.string,
        fontStyle: PropTypes.oneOf(['uppercase', 'regular']),
        buttonTextColor: PropTypes.string,
        buttonTextColorStyle: PropTypes.oneOf(Object.keys(COLOR_STYLE)),
        buttonStyle: PropTypes.oneOf(['solid', 'outline']),
        buttonColor: PropTypes.string,
        backgroundColorButtonStyle: PropTypes.oneOf(Object.keys(COLOR_STYLE)),
        outlineColor: PropTypes.string,
        outlineColorStyle: PropTypes.oneOf(Object.keys(COLOR_STYLE)),
        termsOfServiceUrl: PropTypes.string
    }

    static contextTypes = {
        flux: PropTypes.object.isRequired
    }

    static defaultProps = {
        title: 'Get the latest news in your inbox!',
        text: 'Sign up for our daily email.',
        overflowBackground: false,
        buttonText: 'Sign Up',
        alignment: 'center',
        buttonStyle: 'solid',
        roundedCorner: 'strong',
        fontStyle: 'uppercase',
        distributionList: [],
        componentTitleType: TITLE_TYPE.MODULE_TITLE,
        successTitle: SUBSCRIBE_SUCCESS_TITLE,
        successMessage: SUBSCRIBE_SUCCESS_TEXT,
        termsOfServiceUrl: ''
    }

    state = {
        subscribed: false,
        isLoading: false,
        messageError: ''
    }

    _handleSubscribe(emailAddress) {
        const {distributionList: emailList} = this.props;
        searchUserByEmail(emailAddress).then(res => {
            const { items = [] } = res;
            if (isEmpty(items)) {
                const memberData = {
                    emailaddress: emailAddress,
                    username: emailAddress,
                    password: generateRandomPassword(),
                    zipcode: ZIPCODE_DEFAULT
                };
                createMember(memberData).then(resp => {
                    const { member, token } = resp;
                    if (member) {
                        subscribe({emailList, token}).then(() => {
                            this.setState({subscribed: true});
                        }).catch(() => {
                            this.setState({messageError: SUBSCRIBE_FAIL, isLoading: false});
                        });
                    }
                }).catch(() => {
                    this.setState({messageError: SUBSCRIBE_FAIL, isLoading: false});
                });
            } else {
                const userId = get(items[0], 'user.id'); 
                subscribe({emailList, userId}).then(() => {
                    this.setState({subscribed: true, isLoading: false});
                }).catch(() => {
                    this.setState({messageError: SUBSCRIBE_FAIL, isLoading: false});
                });
            }
        }).catch(() => {
            this.setState({messageError: SUBSCRIBE_FAIL, isLoading: false});
        });
        this.setState({isLoading: true});
    }

    _onSubscribe(e) {
        e.preventDefault();
        const emailAddress = e.target.elements['email'].value.trim();
        let messageError = validateEmail(emailAddress);
        
        if (!messageError) {
            this._handleSubscribe(emailAddress);
        }

        this.setState({messageError});
    }

    _removeErrorMessage() {
        this.setState({messageError: ''});
    }

    renderForm(styleBackground) {
        const {
            buttonText,
            fontStyle,
            roundedCorner,
            buttonStyle,
            buttonTextColor,
            buttonTextColorStyle,
            backgroundColorButtonStyle,
            buttonColor,
            outlineColor,
            outlineColorStyle,
            termsOfServiceUrl = ""
        } = this.props;

        const { messageError, isLoading } = this.state;
        
        const submitClassName = classNames(
            'CustomCol',
            `col-md-${GRID_SYSTEM[`${styleBackground}`].submitForm}`,
            'form-group',
            'SubmitForm'
        );
        const emailFieldClassName = classNames(
            'CustomCol',
            'email',
            `StyleBorder-${roundedCorner}`
        );
        const buttonSubmitClassName = classNames(
            'CustomCol',
            'button',
            `StyleBorder-${roundedCorner}`,
            `button-style--${buttonStyle}`,
            `button-text--${fontStyle}`,
            {[`frn-u-foreground-${buttonTextColorStyle}`]: buttonTextColorStyle},
            {[`frn-u-background-${backgroundColorButtonStyle}`]: backgroundColorButtonStyle},
            {[`frn-u-outline-${outlineColorStyle}`]: outlineColorStyle}
        );

        return (                
                <div className={submitClassName}>
                    <div className="SubmitForm-ErrorMessage form-group">{messageError}</div>                        
                    <input
                        onChange={() => this._removeErrorMessage()}
                        className={emailFieldClassName}
                        type="text"
                        name="email"
                        placeholder="Your Email"
                    />
                    {!isLoading &&
                    <input 
                        style={{color: buttonTextColor, borderColor: outlineColor, backgroundColor: buttonColor}}
                        className={buttonSubmitClassName}
                        type="submit"
                        value={buttonText}
                    />}
                    {isLoading && 
                    <div className={ classNames('app--spinner', { active: isLoading }) } />}
                    {termsOfServiceUrl && <div className="Agreement form-group">By signing up, I agree to the <a href={termsOfServiceUrl}>Terms of Service</a>.</div>}
                </div>
        );
    }

    renderSubscribeForm(styleBackground) {
        const {
            title,
            titleColor,
            text,
            textColor,
            backgroundColor,
            overflowBackground,
            alignment
        } = this.props;

        const FormClassName = classNames(
            'col-sm-12',
            'form-inline',
            'Form',
            `Form-${alignment}`,
            `Form-${styleBackground}`
        );
        const titleClassName = classNames(
            'col-md-12',
            'Form-Title',
            `Form-Title--${styleBackground}`
        );
        const textClassName = classNames(
            `col-md-${GRID_SYSTEM[`${styleBackground}`].text}`,
            'form-group',
            'Form-Text'
        );
       
        
        return (
            <form className={FormClassName} style={{backgroundColor}} onSubmit={e => this._onSubscribe(e)}>
                {
                    !overflowBackground && 
                    <div className="CustomCol">
                        <div className={titleClassName} style={{color: titleColor}}>
                            {title}
                        </div> 
                        <div className={textClassName} style={{color: textColor}}>
                            {text}
                        </div>
                        {this.renderForm(styleBackground)}
                    </div>
                }
                {
                    overflowBackground &&
                    <div className="container">
                        <div className="col-md-7">
                            <span className={titleClassName} style={{titleColor}}>{title}</span>. <span style={{textColor}}>{text}</span>
                        </div>
                        <div className="CustomCol">
                            {this.renderForm(styleBackground)}
                        </div>
                    </div>
                }
            </form>
        );
    }

    renderNotification() { 
        const { successTitle, successMessage, backgroundColor } = this.props;
        return (
            <div className="Form Form-Notification" style={{backgroundColor}}>
                <span className="Form-Title title">{successTitle}</span>
                <span>{successMessage}</span>
            </div>
        );
    }
    
    render() {
        const { overflowBackground, alignment, componentTitle, componentTitleType } = this.props;
        const { subscribed } = this.state;

        const WrapperClassName = classNames(
            'Newsletter',
            `Newsletter-${alignment}`,
            {'Newsletter-overflow': overflowBackground},
        );
        const styleBackground = overflowBackground ? 'overflow' : 'basic';

        return (
            <div className={WrapperClassName}>
                {componentTitle ? <ComponentTitle titleType={componentTitleType} title={componentTitle} showArrow={false} /> : null}
                {!subscribed && this.renderSubscribeForm(styleBackground)}
                {subscribed && this.renderNotification()}
            </div>
            );
    }
}

export default NewsletterSubscribe;



// WEBPACK FOOTER //
// ./app/components/membership/NewsletterSubscribe.js